export const blobToBase64 = (blob: Blob): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result as string);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};

export const base64ToFile = (base64: string, filename: string): File => {
  // Vérification du format de la chaîne Base64
  if (!base64.startsWith('data:')) {
    throw new Error('La chaîne Base64 doit commencer par "data:".');
  }

  // Extraire le type MIME et les données encodées en Base64
  const match = base64.match(/^data:(.*?);base64,(.+)$/);
  if (!match || match.length !== 3) {
    throw new Error('La chaîne Base64 est invalide ou mal formatée.');
  }

  // Récupération du type MIME (image/png, application/json, etc.)
  const mimeType = match[1];
  // Données encodées en Base64
  const base64Data = match[2];

  // Décoder les données Base64 en un tableau d'octets
  const byteCharacters = atob(base64Data);
  const byteNumbers = Array.from(byteCharacters).map((char) =>
    char.charCodeAt(0),
  );
  const byteArray = new Uint8Array(byteNumbers);

  // Créer un fichier avec le type MIME approprié
  return new File([byteArray], filename, { type: mimeType });
};
